<template>
  <div class="header-notify">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.header {
  &-notify {
    :deep() {
      > * {
        padding: 8px;
        width: 100%;
        text-align: center;
        line-height: 1.2;
        button {
          display: inline;
        }
      }
      .color-blue {
        color: #0044ff;
        background-color: rgba(0, 123, 255, 0.1);
      }
      .color-red {
        color: #ff0000;
        background-color: rgba(255, 0, 0, 0.1);
      }
      .color-grey {
        color: #808080;
        background-color: rgba(128, 128, 128, 0.1);
      }
    }
  }
}
</style>
